import AdyenCheckout from "@adyen/adyen-web";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OrderSocketService } from "src/app/core/services/order-socket.service";
import { PaymentService } from "src/app/core/services/payment.service";
import { environment } from "src/environments/environment";
import { AddressModel } from "../../models/address.model";
import { FocusPayPaymentSession } from "../../models/DTO/focuspay.paymentSession.dto";
import { I4goPaymentResponseDTO } from "../../models/DTO/I4goPaymentRequest.dto";
import { AppMessageSeverity } from "../../models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-focuspay-payment",
	templateUrl: "./focuspay-payment.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class FocuspayPaymentComponent implements OnInit {
	@ViewChild("cardContainer") cardContainer: ElementRef;
	@Input() checkKey: string;
	@Input() transactionAmount: number;
	@Input() paymentKey: string;
	@Input() processorResponse: object;
	@Output() processorResponseChange = new EventEmitter<object>();

	@Input() deliveryAddress: AddressModel;

	paymentSessionConfiguration;

	constructor(public app: AppService, public paymentService: PaymentService, public focuslink: FocuslinkService, public orderSocket: OrderSocketService) {}

	ngOnInit(): void {
		console.log("init focuspay");
		if (!this.paymentService.paymentSession.value.id) {
			console.log("session does not exist");
			this.paymentService.startSession(this.transactionAmount, this.checkKey);
			this.paymentService.paymentSession.subscribe((data) => {
				if (data.id) {
					console.log("paymentsession data");
					console.log(data);
					this.createPaymentConfiguration(data);
					this.initPaymentForm();
				}
			});
		} else {
			console.log("session exists");
			this.createPaymentConfiguration(this.paymentService.paymentSession.value);
			this.initPaymentForm();
		}
	}

	createPaymentConfiguration(sessionData: FocusPayPaymentSession) {
		this.paymentSessionConfiguration = {
			paymentMethodsResponse: this.paymentService.paymentMethods,
			environment: "test", // Change to 'live' for the live environment.
			clientKey: environment.adyenClientKey, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
			showPayButton: true,
			session: {
				id: sessionData.id, // Unique identifier for the payment session.
				sessionData: sessionData.sessionData, // The payment session data.
			},
			onPaymentCompleted: (result, component) => {
				console.log(result);
				switch (result.resultCode) {
					case "Refused": {
						this.app.msgSvc.add({
							severity: AppMessageSeverity.RED,
							summary: "",
							detail: `Sorry, the credit card was ${result.resultCode}.\nPlease try another card.`,
						});
						break;
					}

					case "Authorised": {
						this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Thanks! Your payment was authorized successfully.` });
						this.processorResponseChange.emit(
							new I4goPaymentResponseDTO({
								amount: this.transactionAmount,
							})
						);
						break;
					}
					default: {
						this.app.msgSvc.add({
							severity: AppMessageSeverity.WARNING,
							summary: "",
							detail: `Sorry, the credit card could not be processed.\nPlease try another card.`,
						});
						break;
					}
				}
			},
			onError: (error, component) => {
				this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: "", detail: `Error occurred: ${error.name}` });
				console.error(error.name, error.message, error.stack, component);
			},
			// Any payment method specific configuration. Find the configuration specific to each payment method:  https://docs.adyen.com/payment-methods
			// For example, this is 3D Secure configuration for cards:
			paymentMethodsConfiguration: {
				card: {
					hasHolderName: true,
					holderNameRequired: true,
				},
			},
		};
	}

	async initPaymentForm() {
		const checkout = await AdyenCheckout(this.paymentSessionConfiguration);
		// Access the available payment methods for the session.
		console.log(checkout); // => { paymentMethods: [...], storedPaymentMethods: [...] }

		// Create an instance of the Component and mount it to the container you created.
		const cardComponent = checkout.create("card").mount(this.cardContainer.nativeElement);
	}

	onSuccessfulPayment() {}
}
